import { MatSnackBar, MatSnackBarDismiss } from '@angular/material/snack-bar';
import { DsLibSnackbarData } from '../interfaces/ds-lib-snackbar-data.interface';
import { DsLibSnackbarComponent } from '../ds-lib-snackbar.component';
import { Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { Observable } from 'rxjs';
import { DsLibSnackbarStates } from '../enums/ds-lib-snackbar-states.enum';

@Injectable({
  providedIn: 'root',
})
export class DsLibSnackbar {
  /**
   * Default duration of snackbar.
   */
  private duration = 4000;

  /**
   * Creates an instance of DsLibSnackbar.
   *
   * @param snackbar Material snackbar
   */
  constructor(private snackbar: MatSnackBar) {}

  /**
   * Opens a ds lib snackbar.
   *
   * @param data Ds lib snackbar data
   * @param duration Optional custom duration for the snackbar
   * @returns Observable<MatSnackBarDismiss>
   */
  public open(data: DsLibSnackbarData, duration?: number): Observable<MatSnackBarDismiss> {
    return this.openFromComponent(DsLibSnackbarComponent, data, duration);
  }

  /**
   * Opens a material snackbar from component given in args.
   *
   * @param component Custom component to open as a snackbar
   * @param data Ds lib snackbar data
   * @param duration Optional custom duration for the snackbar
   * @returns Observable<MatSnackBarDismiss>
   */
  public openFromComponent<T>(
    component: ComponentType<T>,
    data: DsLibSnackbarData,
    duration?: number
  ): Observable<MatSnackBarDismiss> {
    const state = data.state || DsLibSnackbarStates.PRIMARY;
    return this.snackbar
      .openFromComponent(component, {
        duration: duration || this.duration,
        panelClass: [state, 'ds-lib-snackbar'],
        data,
      })
      .afterDismissed();
  }

  /**
   * Opens the material snackbar.
   *
   * @param message Message to display inside snackbar
   * @param duration Optional custom duration for the snackbar
   * @returns Observable<MatSnackBarDismiss>
   */
  public materialOpen(message: string, duration?: number): Observable<MatSnackBarDismiss> {
    return this.snackbar.open(message, null, { duration: duration || this.duration }).afterDismissed();
  }
}
